/* ════════════════════════════════════════════════════════════
   section-filter-grid.js
   Per-section filter pill behavior:
   - Click a pill → it becomes .is-active, others lose it
   - Cards with matching data-filters stay visible, others get
     .is-hidden (display: none)
   - "All" pill (data-filter="all") shows every card
   ════════════════════════════════════════════════════════════ */

(function () {
  function initFilterGrid(section) {
    if (!section || section.__filterGridInit) return;
    section.__filterGridInit = true;

    var buttons = section.querySelectorAll('.filter-grid__filter');
    var cards = section.querySelectorAll('.filter-grid__card');

    if (!buttons.length || !cards.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-filter') || 'all';

        // Update pill active state
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        // Filter cards
        cards.forEach(function (card) {
          var cardFilters = (card.getAttribute('data-filters') || '')
            .split(/\s+/)
            .filter(Boolean);
          var shouldShow = filter === 'all' || cardFilters.indexOf(filter) !== -1;
          card.classList.toggle('is-hidden', !shouldShow);
        });
      });
    });
  }

  // Initial bind
  document.querySelectorAll('.filter-grid').forEach(initFilterGrid);

  // Theme-editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.filter-grid');
    if (section) initFilterGrid(section);
  });
})();